import { type ReactNode } from "react";

import { type ButtonProps } from "ui/button/button.types";

export const LoadingButtonState = {
  Default: "default",
  Loading: "loading",
  Success: "success",
  Error: "error",
} as const;

export type LoadingButtonState = (typeof LoadingButtonState)[keyof typeof LoadingButtonState];

export type LoadingButtonIconPhase = (readonly [
  "hidden",
  "rotating",
  "scaling",
  "visible",
])[number];

export type LoadingButtonIconProps = {
  errorIcon?: ReactNode | null;
  loadingIcon?: ReactNode | null;
  state: LoadingButtonState;
  successIcon?: ReactNode | null;
};

export type AsyncButtonProps = ButtonProps & LoadingButtonIconProps & {
  errorDuration?: number;
  errorMessage?: ReactNode;
  loadingMessage?: ReactNode;
  successDuration?: number;
  successMessage?: ReactNode;
};
